import React, { useEffect } from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import getDesignTokens from './themes/theme'
import constants from './config/constants'
import ScrollToTop from './components/_common/_helpers/scrollToTop'
import HomeWrapper from './components/home/HomeWrapper'

function App() {
  const appTheme = createTheme(getDesignTokens())

  useEffect(() => {
    const currentVersion = localStorage.getItem('appVersion');
    
    if (!currentVersion || (currentVersion && currentVersion !== constants.app_version)) {
      localStorage.setItem('appVersion', constants.app_version)
      
      setTimeout(() => {
        window.location.reload()
      }, 100)      
    } else {
      localStorage.setItem('appVersion', constants.app_version)
    }
  }, [])

  return (
    <ThemeProvider theme={appTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <BrowserRouter>
          <ScrollToTop />
          <CssBaseline enableColorScheme />
          <Routes>
            <Route exact path='/' element={<HomeWrapper />} />
            <Route exact path='/email-validation/:userId/:validationString' element={<HomeWrapper />} />
            <Route path='/password-reset/:userId/:validationString' element={<HomeWrapper />} />
            <Route exact path='*' element={<HomeWrapper />} />
          </Routes>
        </BrowserRouter>
      </LocalizationProvider>      
    </ThemeProvider>
  )
}

export default App